__turbopack_context__.v({
  "blocksBackgroundColor": "Markdown-module-scss-module__xwelDa__blocksBackgroundColor",
  "blocksFontColor": "Markdown-module-scss-module__xwelDa__blocksFontColor",
  "markdown": "Markdown-module-scss-module__xwelDa__markdown",
  "secondaryNavBackgroundColor": "Markdown-module-scss-module__xwelDa__secondaryNavBackgroundColor",
  "themeBackgroundColor": "Markdown-module-scss-module__xwelDa__themeBackgroundColor",
  "themeFontColor": "Markdown-module-scss-module__xwelDa__themeFontColor",
});
